import { InputAdornment } from "@material-ui/core";
import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import React, { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MemoizedButton } from "../../../SDK/button";
import { MemoizedPhoneField } from "../../../SDK/input/phoneInput";
import { checkError } from "../../../SDK/utils/validationHelpers";
import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import UseBookEVConsultation from "../../Home/BookEVconsult/useBookEVConsultation";

const CustomVehicleDetail = styled(Box)(({ theme }) => ({
  width: "85%",
  ".vehicle_details": {
    borderRadius: "6px",
    border: "1.5px solid #F4F4F4",
    background: primary.lightGrey,
    padding: "16px",
  },

  ".Vehicle_Name_Container": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "18px 0 24px 0",
    ".vehicle_name": {
      fontSize: "20px",
      textTransform: "capitalize",
      fontWeight: "600",
    },
    ".logo-img": {
      objectFit: "contain",
      maxHeight: "30px",
      minWidth: "30px",
    },
  },
  ".vehicle_specifications": {
    margin: "20px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  ".feature": {
    fontWeight: "600",
    fontSize: "22px",
    display: "flex",
    justifyContent: "center",

  },
  ".vehicle_pricing": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "0px 0px 5px 6px",
    background: primary.lightGreen,
    padding: "16px",
    ".price": {
      fontSize: "26px",
      fontWeight: "700",
      color: primary.mainGreen,
    },
  },
  ".lead_form": {
    padding: "24px 16px",
    borderRadius: "5px",
    background: primary.white,
    boxShadow: "0px -6px 15px 0px rgba(150, 150, 150, 0.20)",
  },
  ".view-btn": {
    borderRadius: "8px",
    boxShadow: "none",
    border: "none",
    paddingLeft: "20px",
    paddingRight: "20px",
    "&:hover": {
      background: "#F63B63",
      border: "none",
      color: "white",
      boxShadow: "none",
      paddingLeft: "20px",
      paddingRight: "20px",
    },
  },
  ".MuiOutlinedInput-root": {
    paddingRight: "2px !important",
    background: "#FEEBEF",
  },
  ".input-field": {
    minWidth: "100% !important",
    paddingRight: "0px",
    overflow: "hidden",
    background: primary.lightMain,
  },
  [theme.breakpoints.down("sm")]: {
    ".input-field": {
      fontSize: "12px",
    },
    ".form-box": {
      margin: "20px 0",
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "92%",
    margin: "auto",
    ".Vehicle_Name_Container": {
      ".vehicle_name": {
        fontSize: "16px",
      },
      ".logo-img": {
        maxHeight: "24px",
        minWidth: "24px",
        maxWidth: "80px",
      },
    },
    ".feature": {
      fontWeight: "600",
      fontSize: "18px",
    },
    ".vehicle_pricing": {
      padding: "12px",
      ".price": {
        fontSize: "22px",
      },
    },

    ".lead_form": {
      alignItems: "center",
      justifyContent: "center",
      background: primary.white,
      bottom: "0",
      boxShadow: "0px 0px 2px 0px rgba(246, 59, 99, 0.10);",
      color: "#333",

      position: "fixed",
      width: "100%",
      zIndex: "999",
      marginLeft: "-14px",

      padding: "10px",
    },
  },
}));
const VehicleDetailsV2 = ({ vehicleData, productType, fixState }) => {
  const state = useContext(Context);
  let location =
    state?.selectedState === "India" ? "Others" : state?.selectedState;
  const { form, loading } = UseBookEVConsultation("Others");

  return (
    <CustomVehicleDetail>
      <Box className="vehicle_details">
        <Grid container className="Vehicle_Name_Container">
          <Typography className="vehicle_name" variant="h1">
            {vehicleData?.brand} {vehicleData?.vehicle_name}
          </Typography>
          <LazyLoadImage
            src={vehicleData?.vehicle_logo}
            alt={vehicleData?.brand}
            className="logo-img"
          />
        </Grid>
        <Grid container className="vehicle_specifications">
          <Stack item xs={4}>
            <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
              Top Range
            </Typography>
            <Typography className="feature">{vehicleData?.range}</Typography>
          </Stack>
          <Stack
            item
            xs={4}
            style={{
              borderLeft: "2px solid grey",
              borderRight: "2px solid grey",
              padding: "0 10px 0 10px",
            }}
          >
            <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
              {vehicleData?.type === "passenger" ? "Cost/100km" : "Top Load"}
            </Typography>
            <Typography className="feature">
              {vehicleData?.type === "passenger"
                ? vehicleData?.costPer100Km
                : vehicleData?.load}
            </Typography>
          </Stack>
          <Stack item xs={4}>
            <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
              Top Speed
            </Typography>
            <Typography className="feature">{vehicleData?.topSpeed}</Typography>
          </Stack>
        </Grid>
        {vehicleData?.isModelDiscontinued && (
          <Typography
            variant="p"
            sx={{
              marginTop: "16px",
              fontSize: { xs: "13px", md: "14px" },
              fontWeight: 400,
              color: "#424242",
              lineHeight: 1.6,
            }}
          >
            <Box component="span" sx={{ fontWeight: 600, color: "#424242" }}>
              This model is discontinued
            </Box>
            {" "}
            <Box component="span" sx={{ fontWeight: 400, color: "#757575" }}>
              Price is for informational purposes only and the same may be subject to change. For details, please go through the T&C.
            </Box>
          </Typography>
        )}
      </Box>
      <Grid container className="vehicle_pricing">
        <Box>
          <Typography className="price">
            ₹{vehicleData?.prices[location][productType?.type]?.price}L
          </Typography>
          <Typography>Ex Showroom Price</Typography>
        </Box>
        <Box>
          <Typography className="price">
            ₹
            {vehicleData?.prices[location][
              productType?.type
            ]?.emiPrice.toLocaleString("en-IN")}
            p.m.
          </Typography>
          <Typography style={{ textAlign: "right" }}>
            EMI Starting from
          </Typography>
        </Box>
      </Grid>
      <Box className="lead_form">
        <Typography style={{ fontWeight: "700", marginBottom: "8px" }}>
          Enter mobile number for on-road price
        </Typography>
        <form onSubmit={form.handleSubmit}>
          <Box className="input-box">
            <MemoizedPhoneField
              error={!!checkError("mobile", form)}
              helperText={form.errors.mobile}
              className="input-field"
              name="mobile"
              placeholder="Your Mobile"
              value={form.values.mobile}
              onChange={(e) => {
                form.handleChange(e);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+91</InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <MemoizedButton
                      className="view-btn"
                      type="submit"
                      content="On Road Price"
                      loading={loading}
                      handleClick={(e) => {
                        form.handleSubmit(e);
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </form>
      </Box>
    </CustomVehicleDetail>
  );
};

export const MemoizedVehicleDetailsV2 = React.memo(VehicleDetailsV2);
